import React from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import "./styles.scss";
import { Spinner } from "react-bootstrap";
//import { ReactComponent as PauseIcon } from "../../../../../public/icons/AudioTag/pause_circle.svg";
import Pause from "../../../../shared/Svg/Pause";
import defaultAlbumImg from "../../../../../public/images/default-alblum-img.png";
import { useSelector } from "react-redux";
import hv_player_api from "../../../../../api/hv_player_api";
import HvProgress from "../../../../App/shared/HvProgress";
import Actions from "../../Actions";
import { ReactComponent as MenuIcon } from "../../../../../public/shared/menu-icon-default.svg";
import { Dropdown } from "react-bootstrap";
import PlayButton from "../../../../shared/Svg/PlayButton";
import RemoveIcon from "../../../../../public/shared/x-remove-icon.png";
import { ReactComponent as EmbedIcon } from "../../../../../public/icons/embedIcon.svg";
import { isSelfId } from "../../../../../api/helper";
import EmbedModal from "../../../../shared/EmbedModal";
import RollOver from "../../../../RollOver";

export default ({ className, medium, mediumSetter, source, showProgress = false, showActions = false, removeMedium = null, user }) => {
  const isMobileDevice = useMediaQuery({
    query: "(max-width: 768px)",
  });
  const controls = useSelector((state) => state);
  const isBeingPlayed = controls.currently_playing && controls.currently_playing.id === medium.id;
  const playMedium = () =>
    source && source != "Comment" ? hv_player_api.playMediaWithSource(medium, source) : hv_player_api.playMediaWithoutSource(medium);
  const removeFromQueue = () => hv_player_api.removeFromQueue(medium);
  return (
    <div className={`audio-tag d-flex w-100 ${className} ${!medium.title ? "no-title" : ""}`}>
      <div className="d-flex">
        <div className="preview-img custom-preview-img">
          <Link to={`/${medium.user.slug}`}>
            <img src={medium.preview_image ? medium.preview_image.url : defaultAlbumImg} alt="ALBUM-THUMBNAIL" />
          </Link>
        </div>

        <div className="controls d-flex align-items-start">
          {isBeingPlayed ? (
            controls.currently_playing.status === "ready" ? (
              controls.playing ? (
                /*
                <PauseIcon
                  className="py-auto"
                  onClick={hv_player_api.pause}
                />*/
                <Pause className="pause-button" onClick={hv_player_api.pause} />
              ) : (
                <PlayButton className="play-button py-auto" onClick={hv_player_api.play} />
              )
            ) : (
              <Spinner animation="border" variant="primary" size="sm" role="status" className="py-auto" style={{ width: "20px", height: "20px" }} />
            )
          ) : (
            <PlayButton className="play-button py-auto" onClick={playMedium} />
          )}
        </div>
      </div>
      <div className="d-flex align-items-center right-content">
        {showProgress && (
          <div className="audio-info flex-column d-flex px-3">
            {isMobileDevice && (
              <EmbedModal object={medium}>
                <RollOver text="embed track">
                  <EmbedIcon className="embed-icon mx-2" />
                </RollOver>
              </EmbedModal>
            )}
            {medium.title && <p className="title m-0 text-black">{medium.title}</p>}
            {medium.user && (
              <Link to={`/${medium.user.slug}`}>
                <p className="m-0 text-default artist-name">{medium.user.username}</p>
              </Link>
            )}
            {isBeingPlayed ? (
              <HvProgress progress={controls.progress} duration={controls.currently_playing.duration} className="w-100" showTimeUnderBar />
            ) : (
              <HvProgress className="w-100" showTimeUnderBar />
            )}
          </div>
        )}

        {showActions && <Actions object={medium} setObject={mediumSetter} user={controls.current_user} />}

        {isSelfId(user && user.id) && (
          <Dropdown>
            <Dropdown.Toggle as={MenuIcon} />
            <Dropdown.Menu>
              <Dropdown.Item onClick={removeFromQueue}>Remove from Queue</Dropdown.Item>
              <Dropdown.Item className="d-flex" e onClick={() => removeMedium(medium.id)}>
                <img src={RemoveIcon} alt="REMOVE PLAYLIST ITEM" className="mr-3" />
                Remove
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
      <div className="d-flex">
        {!isMobileDevice && (
          <EmbedModal object={medium}>
            <RollOver text="embed track">
              <EmbedIcon className="embed-icon" />
            </RollOver>
          </EmbedModal>
        )}
      </div>
    </div>
  );
};
